import React from 'react';
import InformationSection from './InformationSection';
import downloadGray from '../../assets/icons/download_gray.svg';

const MetricsProgressPage = ({ 
  hasError = false, 
  handleEvaluate,
  processingStatus,
  selectedMetricIds = []
}) => {
  const progressValue = typeof processingStatus?.progress === 'number'
    ? Math.max(0, Math.min(100, processingStatus.progress))
    : null;
  const statusValue = processingStatus?.status || 'starting';
  const statusStyle = (() => {
    const normalized = String(statusValue).toLowerCase();
    if (normalized === 'completed' || normalized === 'succeeded') {
      return 'bg-[#ECFDF3] border-[#A7F3D0] text-[#047857] shadow-[0_0_12px_rgba(16,185,129,0.35)]';
    }
    if (normalized === 'error' || normalized === 'failed') {
      return 'bg-[#FEF2F2] border-[#FECACA] text-[#B91C1C] shadow-[0_0_12px_rgba(239,68,68,0.3)]';
    }
    return 'bg-[#EFF6FF] border-[#BFDBFE] text-[#1D4ED8] shadow-[0_0_10px_rgba(59,130,246,0.25)]';
  })();

  if (hasError) {
    return (
      <div className="px-4 md:px-0">
        <div className="bg-white border rounded-lg p-4 md:p-6 mb-6">
          <h2 className="text-lg font-semibold mb-2">Metrics Error</h2>
          <p className="text-red-500">
            Failed to run metrics. Please try again.
          </p>
          <div className="mt-4">
            <button
              onClick={handleEvaluate}
              className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              <span>Retry</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="px-4 md:px-0">

      {/* <div className="border border-[#E2E8F0] rounded-lg p-4 mb-8">
        <h1 className="text-2xl font-bold mb-2">
          Evaluating Metrics
        </h1>
        <p className="text-[#6B7280] text-medium w-full mb-6">
          We're analyzing your content. The evaluation process typically takes 5-20 minutes depending on file size and selected metrics.
        </p>
        
        <div className="mb-6">
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-blue-500 transition-all duration-1000 ease-out animate-pulse"
              style={{ width: '60%' }}
            />
          </div>
        </div>

        {showEmailModal && (
          <div className="bg-[#F9FAFB] border border-[#E2E8F0] rounded-2xl p-4">
            <p className="text-gray-700 mb-4">
              Please leave your email, and we will send you the results as soon as the evaluation is finished.
            </p>
            <div className="flex gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className={`flex-1 px-3 py-2 max-w-[360px] h-[36px]
                border border-[#E2E8F0] shadow-[0px_1px_2px_0px_#0208170D] rounded-md 
                focus:outline-none focus:ring-0 ${emailError ? 'border-[#EF4444]' : ''}`}
              />
              <button
                onClick={handleEmailSubmit}
                disabled={emailSuccess}
                className="flex items-center px-4 py-2 h-[36px] bg-[#020817] text-white rounded-md
                shadow-[0px_1px_2px_0px_#0000000D] 
                hover:bg-[#29303D] disabled:bg-[#E2E8F0] disabled:text-[#9CA3AF] disabled:cursor-not-allowed"
              >
                Submit
              </button>
            </div>
            {emailError && (
              <p className="text-red-500 text-sm mt-2">{emailError}</p>
            )}
            {emailSuccess && (
              <p className="text-green-500 text-sm mt-2">
                Email saved! You'll be notified when it's ready.
              </p>
            )}
          </div>
        )}
      </div> */}

      <div className="mb-8">
        <div className="rounded-2xl border border-[#E2E8F0] bg-gradient-to-br from-white via-[#F8FAFC] to-[#EEF2FF] p-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h2 className="text-3xl font-bold mb-2 text-[#020817]">
                Metrics in progress
              </h2>
              <p className="text-[#6B7280] text-medium max-w-[720px]">
                We are running the selected metrics. You will be redirected once results are ready.
              </p>
              {processingStatus && (
                <div className="mt-4 flex flex-wrap items-center gap-3 text-sm">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full border ${statusStyle}`}>
                    <span className="mr-2 inline-flex h-2.5 w-2.5">
                      <span className="animate-ping absolute inline-flex h-2.5 w-2.5 rounded-full bg-current opacity-30" />
                      <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-current" />
                    </span>
                    Status: <span className="ml-2 font-medium">{statusValue}</span>
                  </span>
                  {progressValue !== null && (
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-white border border-[#E2E8F0] text-[#020817] font-medium">
                      {progressValue}%
                    </span>
                  )}
                  {processingStatus?.status === 'succeeded' && (
                    <span className="text-[#2563EB] inline-flex items-center">
                      Finalizing results
                      <span className="ml-1 flex items-center">
                        <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse [animation-delay:0ms]" />
                        <span className="ml-1 h-1.5 w-1.5 rounded-full bg-current animate-pulse [animation-delay:200ms]" />
                        <span className="ml-1 h-1.5 w-1.5 rounded-full bg-current animate-pulse [animation-delay:400ms]" />
                      </span>
                    </span>
                  )}
                </div>
              )}
            </div>
            <div className="flex gap-3">
              <button disabled={true} className="px-4 py-2 border border-[#E2E8F0] bg-[#F9FAFB] text-[#9CA3AF] rounded-md 
              hover:bg-gray-200 flex items-center gap-2">
              <img src={downloadGray} alt="Download CSV" className="w-4 h-4" />
                Download CSV
              </button>
            </div>
          </div>

          <div className="mt-6">
            <div className="h-2 bg-[#E2E8F0] rounded-full overflow-hidden">
              <div
                className="h-full bg-[#2563EB] transition-all duration-300"
                style={{ width: `${progressValue ?? 0}%` }}
              />
            </div>
            <div className="mt-4 rounded-xl border border-[#DBEAFE] bg-[#EFF6FF] px-4 py-3 text-sm text-[#1E3A8A] shadow-[0_6px_16px_rgba(59,130,246,0.12)]">
              <div className="flex items-start gap-2">
                <span className="text-base">✨</span>
                <div>
                  <div className="font-semibold">Tip: take a break.</div>
                  <div className="text-[#1D4ED8]">
                    You can close this tab — we’ll email you when the results are ready. Some runs can take longer than an hour depending on size and load.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-white border border-gray-200 rounded-lg overflow-hidden">
          <div className="flex items-center justify-between px-4 py-3 bg-[#F9FAFB] border-b border-[#E2E8F0]">
            <div className="text-sm font-medium text-[#020817]">Sample results</div>
            <div className="text-xs text-[#6B7280]">Updating as metrics complete</div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-white">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Target</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Reference</th>
                  {(selectedMetricIds.length > 0 ? selectedMetricIds : ['nTER', 'BLEU', 'ChrF', 'BERTScore', 'COMET']).map((metricId) => (
                    <th
                      key={metricId}
                      className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {metricId}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-[#E2E8F0]">
                {Array.from({ length: 5 }, (_, i) => (
                  <tr key={i} className="animate-pulse">
                    <td className="px-4 py-3">
                      <div className="bg-[#E2E8F0] h-4 w-6 rounded"></div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="bg-[#E2E8F0] h-4 w-24 rounded"></div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="bg-[#E2E8F0] h-4 w-24 rounded"></div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="bg-[#E2E8F0] h-4 w-24 rounded"></div>
                    </td>
                    {(selectedMetricIds.length > 0 ? selectedMetricIds : ['nTER', 'BLEU', 'ChrF', 'BERTScore', 'COMET']).map((metricId, index) => (
                      <td key={`${metricId}-${index}`} className="px-4 py-3">
                        <div className="bg-[#E2E8F0] h-4 w-12 rounded"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
       </div>

        <InformationSection />
     </div>
   );
 };

export default MetricsProgressPage;
